import { DadosUsuarioHome } from '../services/api'
import { user } from '../helpers/user'
import { formatPrice } from '../utils/formatPrice'
import { useQuery } from 'react-query'
import { useState } from 'react'

async function getUserData(cod) {
  const { data } = await DadosUsuarioHome.get(`/${cod}`)

  data.vendas_mes = formatPrice(data.vendas_mes)
  data.vendas_semana = formatPrice(data.vendas_semana)

  data.pedido_proximo =
    data.valor_pedidos_mes - data.valor_pedido_baixo <= 0
      ? 1
      : data.valor_pedidos_mes - data.valor_pedido_baixo

  data.ranking_valor_proximo =
    parseInt(data.ranking_vendas_mes) == 10
      ? 10
      : parseInt(data.ranking_vendas_mes) + 1

  data.valor_a_alcancar =
    parseFloat(data.valor_venda_cima) - parseFloat(data.valor_vendas_mes)

  data.valor_proximo =
    parseFloat(data.valor_vendas_mes) - parseFloat(data.valor_venda_baixo)

  data.ranking_valor_a_alcancar =
    parseInt(data.ranking_vendas_mes) == 1
      ? 1
      : parseInt(data.ranking_vendas_mes) - 1

  data.ranking_pedido_a_alcancar =
    parseInt(data.ranking_pedidos_mes) === 1
      ? 1
      : parseInt(data.ranking_pedidos_mes) - 1

  data.pedido_a_alcancar =
    data.valor_pedido_cima - data.valor_pedidos_mes <= 0
      ? 1
      : data.valor_pedido_cima - data.valor_pedidos_mes

  data.total_pedidos_vendedor =
    parseInt(data.aprovacoes) +
    parseInt(data.pedidos_producao) +
    parseInt(data.pedidos_expedicao)

  return data
}

export const useInfoCustomer = () => {
  const [codCustomerSelected, setCodCustomerSelected] = useState(
    user?.codigo_usuario !== 30 ? user?.codigo_usuario : 0,
  )

  console.log(codCustomerSelected)

  const { data, isLoading } = useQuery({
    queryKey: ['users-customers-selected', codCustomerSelected],
    queryFn: () => getUserData(codCustomerSelected),
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  })

  return {
    infoCustomer: data,
    isLoading,
    codCustomerSelected,
    setCodCustomerSelected,
  }
}
